import { logUsage } from 'owa-analytics';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import truncateCountForDataPointAggregation from 'owa-mail-store/lib/utils/truncateCountForDataPointAggregation';

export function logRPCountInfoBarDatapoints(messages: InfoBarMessageViewState[]) {
    const count = messages.length;
    if (count > 0) {
        const eventName = 'RPCountInfoBar';
        // Log "RPCountInfoBar" to track the # of info bars per item.
        logUsage(eventName, [
            truncateCountForDataPointAggregation(count, false /* shouldAccountForZero */),
        ]);

        // Log "RPCountInfoBar_[infoBarMessageKey]" to track the # of times we show each type of info bar.
        messages.forEach(message => {
            const dataPointName = `${eventName}_${message.key}`;
            logUsage(dataPointName);
        });
    }
}
